import { graphql } from "@/lib/gql/__generated__/gql";

export const ExistingRoomI18nEditQuery = graphql(`
	query ExistingRoomI18nEdit($hotelID: ID!, $roomID: ID!, $lang: LangCode!) {
		roomI18n(hotelID: $hotelID, roomID: $roomID, lang: $lang) {
			id
			lang
			hotelID
			roomID
			article {
				bucket
				key
				region
				mimeType
				fileName
			}
			articleTitle
			name
			catchCopy
			description
			address {
				nationality
				postalCode
				state
				pref
				city
				town
				other
			}
		}
	}
`);
